module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "client-register"
  }, [_c('div', {
    staticClass: "register-img"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../../assets/img/index/logo_new.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "dec-img",
    attrs: {
      "src": _vm.showText.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "register-dec"
  }, [_c('h1', [_vm._v(_vm._s(_vm.showText.slogan))]), _vm._v(" "), _c('div', {
    staticClass: "register-dec-content"
  }, _vm._l((_vm.showText.subSlogans), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dec-item"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/img/register/icon_check.svg"),
        "alt": ""
      }
    }), _c('span', [_vm._v(_vm._s(item))])])
  }), 0)])]), _vm._v(" "), (!_vm.successRegister) ? _c('div', {
    staticClass: "register-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.showText.title))]), _vm._v(" "), _c('el-form', {
    ref: "registerForm",
    attrs: {
      "label-position": "top",
      "status-icon": "",
      "model": _vm.registerForm,
      "rules": _vm.registerRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "您的称呼",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "form-input name",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入您的姓名"
    },
    model: {
      value: (_vm.registerForm.name),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "name", $$v)
      },
      expression: "registerForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    staticClass: "form-input mobile",
    attrs: {
      "maxlength": 15,
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.registerForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "mobile", _vm._n($$v))
      },
      expression: "registerForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "validate-code",
    attrs: {
      "label": "验证码",
      "prop": "validate"
    }
  }, [_c('el-input', {
    staticClass: "form-input validate",
    attrs: {
      "maxlength": 6,
      "placeholder": "请输入手机验证码"
    },
    model: {
      value: (_vm.registerForm.validate),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "validate", $$v)
      },
      expression: "registerForm.validate"
    }
  }), _vm._v(" "), _c('el-button', {
    class: "code-button",
    attrs: {
      "disabled": !!_vm.smsCodeRemain
    },
    on: {
      "click": _vm.getSmsCode
    }
  }, [_vm._v(_vm._s(_vm.smsCodeRemain > 0 ? _vm.smsCodeRemain + '秒' : '获取验证码'))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "company"
    }
  }, [_c('el-input', {
    staticClass: "form-input company",
    attrs: {
      "maxlength": 20,
      "placeholder": "请输入企业名称"
    },
    model: {
      value: (_vm.registerForm.company),
      callback: function($$v) {
        _vm.$set(_vm.registerForm, "company", $$v)
      },
      expression: "registerForm.company"
    }
  })], 1)], 1), _vm._v(" "), (_vm.tipList.show) ? _c('el-alert', {
    attrs: {
      "title": _vm.tipList.title,
      "type": _vm.tipList.type,
      "center": "",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: ("submit-button " + _vm.errorStyle),
    attrs: {
      "disabled": _vm.canSubmit
    },
    on: {
      "click": _vm.submitMessage
    }
  }, [_vm._v("立即注册\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.successRegister) ? _c('div', {
    staticClass: "register-success"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("甄云顾问将会联系您并为您提供专业的讲解与演示")]), _vm._v(" "), _c('p', [_vm._v("您可关闭当前页面，继续浏览甄云产品！")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/register/icon_check.svg"),
      "alt": "恭喜您，注册成功"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("恭喜您，注册成功！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb41d28"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/index.vue
// module id = 699
// module chunks = 12